import { render, staticRenderFns } from "./UserRating.vue?vue&type=template&id=1d531bb7&scoped=true"
import script from "./UserRating.vue?vue&type=script&lang=js"
export * from "./UserRating.vue?vue&type=script&lang=js"
import style0 from "./UserRating.vue?vue&type=style&index=0&id=1d531bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d531bb7",
  null
  
)

export default component.exports